export default {
	'no-items-to-show': 'لا توجد مواد في الخطة لهذه الفترة',
	'material-name': 'اسم المادة',
	'form-type': 'نوع النموذج',
	quantity: 'الكمية',
	classification: 'التصنيف',
	search: 'بحث',
	reset: 'إعادة تعيين',
	'from-date': 'من',
	'to-date': 'إلى',
}
